<!--
 * @Author: fengzhongmei
 * @Date: 2020-06-18 11:01:59
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-12-20 15:18:33
 * @Description: 描述
 * @Copyright: Cloud-Star. Co. Ltd. All rights reserved.
-->
<template>
    <!--倒计时-->
    <div class="countdown"
         v-show="show">
        <div class="content"
             :style="'width:'+(width?width:'400')+'px'">
            <img src="@/assets/images/console/countdown.png" />
            <div>
                <b>{{txt}}！</b>
                <p> <span>{{count}}{{$t('秒后进入')}}{{jumpTxt}}</span>
                    <a @click="goChoicePeople('link')">{{btnText ? btnText : $t('查看订单')}}</a>
                </p>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'countdown',
    props: ['txt', 'jumpTxt', 'jumpLink', 'width', 'btnText'],
    data () {
        return {
            show: false,
            count: '',
            timer: null
        }
    },
    created () {
        clearInterval(this.timer)
    },
    beforeDestroy () {
        clearInterval(this.timer)
    },
    methods: {
        // 5秒后跳转页面
        goChoicePeople (type) {
            this.show = true
            if (type) {
                clearInterval(this.timer)
                this.timer = null
                this.$router.push({ path: this.jumpLink })
            } else {
                const TIME_COUNT = 5
                if (!this.timer) {
                    this.count = TIME_COUNT
                    this.timer = setInterval(() => {
                        if (this.count > 1 && this.count <= TIME_COUNT) {
                            this.count--
                        } else {
                            clearInterval(this.timer)
                            this.timer = null
                            // 跳转到指定页面
                            this.$router.push({
                                path: this.jumpLink
                            })
                        }
                    }, 1000)
                }
            }
        }
    }
}
</script>
<style lang="less" scoped>
.countdown {
    position: absolute;
    left: 0;
    top: 0px;
    height: 100%;
    width: 100%;
    background: #fff;
    text-align: center;
    z-index: 10;
    .content {
        width: 400px;
        margin: 20% auto 0 auto;
        position: relative;
        display: flex;
        align-items: center;
        img {
            width: 150px;
            padding: 0 15px 0 0;
        }
    }
    b {
        color: rgb(9, 192, 104);
        display: block;
        font-size: 16px;
        text-align: left;
        margin-top: 10px;
    }
    span {
        color: #999;
        float: left;
        display: block;
        font-size: 12px;
        padding: 15px 0 10px 0;
    }
    a {
        float: left;
        display: inline-block;
        padding: 5px 20px;
        background: #1f68b3;
        color: #fff;
        font-size: 12px;
        margin: 10px 0 0 10px;
    }
}
</style>
